import { AdvancedMarker, AdvancedMarkerAnchorPoint, useAdvancedMarkerRef, useMap } from '@vis.gl/react-google-maps'
import { ReactElement } from 'react'
import styled from 'styled-components'

import { CirclePinIcon } from 'components/Icons/CirclePinIcon'
import { PinIcon } from 'components/Icons/PinIcon'

const MarkerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const StopsCount = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  color: #fff;
  text-align: center;
  display: flex;
  align-items: center;
  gap: 2px;
`

interface IFeaturesClusterMarkerProps {
  position: google.maps.LatLngLiteral
  size: number
  sizeAsText: string
  getClusterExpansionZoom: (clusterId: number) => number
  clusterId: number
}

export const FeaturesClusterMarker = ({
  position,
  size,
  sizeAsText,
  getClusterExpansionZoom,
  clusterId
}: IFeaturesClusterMarkerProps): ReactElement => {
  const [markerRef] = useAdvancedMarkerRef()
  const map = useMap()
  let iconWidth: number
  let iconHeight: number

  if (size < 100) {
    iconWidth = 94
    iconHeight = 94
  } else if (size < 200) {
    iconWidth = 128
    iconHeight = 128
  } else {
    iconWidth = 179
    iconHeight = 179
  }

  const handleMarkerClick = (): void => {
    const expansionZoom = Math.min(getClusterExpansionZoom(clusterId), 20)
    map?.setZoom(expansionZoom)
    map?.panTo({ lat: position.lat, lng: position.lng })
  }

  return (
    <AdvancedMarker
      ref={markerRef}
      position={position}
      zIndex={size}
      anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
      onClick={handleMarkerClick}
    >
      <MarkerContainer>
        <CirclePinIcon fillColor="#5D59D7" width={iconWidth} height={iconHeight} />
        <StopsCount>
          <PinIcon fillColor="#fff" width={12} height={14} />
          {sizeAsText}
        </StopsCount>
      </MarkerContainer>
    </AdvancedMarker>
  )
}
